import { render, staticRenderFns } from "./PaidWarrantsProcessedDetails.vue?vue&type=template&id=bcfdcfb2&"
import script from "./PaidWarrantsProcessedDetails.vue?vue&type=script&lang=js&"
export * from "./PaidWarrantsProcessedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports